import Image1 from "../../assets/growthbuk.png";
import Image2 from "../../assets/ranjan_technologies.png";

export const Data = [
  {
    id: 1,
    image: Image1,
    title: "GrowthBuk",
    description:
      "We are pleased to extend our heartfelt congratulations and appreciation for his exceptional work as an Intern - Web Developer. His dedication and contributions have been outstanding.",
  },
  {
    id: 2,
    image: Image2,
    title: "Ranjan Technologies",
    description:
      "During his internship he has demonstrated his skills with self-motivation to learn new skills. His performance exceeded our expectations.",
  },
];